import React from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import HostReportTable from './HostReportTable';
import { useTranslation } from 'react-i18next';

const HostReport: React.FC = () => {
    const { t } = useTranslation();
    return (
        <OpPage title={t('hostReport.title')} tooltip={t('hostReport.tooltip')} >
            <HostReportTable />
        </OpPage>
    );
}

export default HostReport;
